import axios from 'axios';
import _ from 'lodash';

const getCannedCMENotes = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios
    .get('/v1/settings/texts?collection=CMENotes', {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(_.sortBy(response.data, 'text'));
      }
      reject('unexpected server response');
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        return reject(err.message);
      }
      reject(err);
    })
  });
};

const getCannedCMEBadDocReasons = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios
    .get('/v1/settings/texts?collection=cmeBadDocReasons', {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(_.sortBy(response.data, 'text'));
      }
      reject('unexpected server response');
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        return reject(err.message);
      }
      reject(err);
    })
  });
};

const getFeaturesToHide = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios
    .get('/v1/settings', {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data ? response.data.featuresToHide : []);
      }
      reject('unexpected server response');
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        return reject(err.message);
      }
      reject(err);
    })
  });
};


const getCannedInternalDQDeleteReasons = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios
    .get('/v1/settings/texts?collection=dqDeleteReasons', {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(_.sortBy(response.data, 'text'));
      }
      reject('unexpected server response');
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        return reject(err.message);
      }
      reject(err);
    })
  });
};

const getCannedInternalDQBadDocReasons = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios
    .get('/v1/settings/texts?collection=dqBadDocReasons', {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(_.sortBy(response.data, 'text'));
      }
      reject('unexpected server response');
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        return reject(err.message);
      }
      reject(err);
    })
  });
};

const getBasics = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios
    .get('/v1/settings/lists?collections=basics', { signal })
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.basics);
      }
      reject('unexpected server response')
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        return reject(err.message);
      }
      reject(err);
    })
  });
};

const getEmploymentStatus = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/lists?collections=employmentStatus`, { signal })
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.employmentStatus);
      }
      reject('unexpected server response')
    }).catch(err => {
      console.error('failed to retrieve lists');
    });
  });
};

const getLicenseClasses = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/lists?collections=licenseClass`, { signal })
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.licenseClass);
      }
      reject('unexpected server response')
    }).catch(err => {
      console.error('failed to retrieve lists');
    });
  });
};

const getDriversLicenseFormatRules = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/lists?collections=driversLicenseFormatRules`, { signal })
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.driversLicenseFormatRules);
      }
      reject('unexpected server response')
    }).catch(err => {
      console.error('failed to retrieve drivers license format rules', err);
      reject(err);
    });
  });
};

const getAllJobTitles = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/lists?collections=jobTitle`, { signal })
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.jobTitles);
      }
      reject('unexpected server response')
    }).catch(err => {
      console.error('failed to retrieve lists');
      if (axios.isCancel(err)) {
        return reject(err.message);
      }
    });
  });
};

const getAllPrograms = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/lists?collections=programs`, {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.programs);
      }
      reject('unexpected server response')
    }).catch(err => {
      console.error('failed to retrieve lists');
    });
  });
};

const getStandardDocument = (standardDocName, signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/documents/${standardDocName}`, { signal })
    .then(res => {
      resolve(res.data);
    })
    .catch(err => {
      console.error(err);
      reject(err);
    });
  });
};

const updateStandardDocument = (standardDocName, docUpdates, signal = null) => {
  return new Promise((resolve, reject) => {
    axios
    .patch(`/v1/settings/documents/${standardDocName}`, docUpdates, { signal })
    .then(response => {
      return resolve();
    })
    .catch(err => {
      console.error('Failed to update note', err);
      reject(err);
    });
  });
};

const getDocsToHide = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/lists?collections=docTypesToHide`, {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.docTypesToHide);
      }
      reject('unexpected server response')
    }).catch(err => {
      console.error('failed to retrieve lists');
    });
  });
};

const getDocsToRequire = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/settings/lists?collections=docTypesRequired`, {signal})
    .then(response => {
      if (response.status === 200) {
        return resolve(response.data.docTypesRequired);
      }
      reject('unexpected server response')
    }).catch(err => {
      console.error('failed to retrieve lists');
    });
  });
};

const getIntegrationTypes = (signal = null) => {
  return new Promise((resolve, reject) => {
    axios.get('/v1/settings/lists?collections=IntegrationTypes', {signal})
    .then(response => {
      resolve(response.data.IntegrationTypes);
    })
    .catch(err => {
      console.error(err);
      reject(err);
    });
  });
}


export default {
  getCannedCMENotes,
  getCannedCMEBadDocReasons,
  getBasics,
  getEmploymentStatus,
  getLicenseClasses,
  getDriversLicenseFormatRules,
  getAllJobTitles,
  getAllPrograms,
  getCannedInternalDQDeleteReasons,
  getCannedInternalDQBadDocReasons,
  getFeaturesToHide,
  getStandardDocument,
  updateStandardDocument,
  getDocsToHide,
  getDocsToRequire,
  getIntegrationTypes
};